import { useState, useEffect } from "react";

import Hero from "./Hero/Hero";
import Certifications from "./Certifications/Certifications";
import AwardsSlider from "./Awards/AwardsSlider";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import useFetch from "Hooks/useFetch.js";

const Awards = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("getcertification");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero data={data?.hero} />
        <AwardsSlider data={data?.awards} />
        <Certifications data={data?.certifications} />
      </main>
    );
  }
};

export default Awards;
